import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

const edu_data = [
   {
      'degree': 'Bachelor',
      'school': 'University of Business and Technolgy',
      'city': 'Pristina',
      'timeline': '2017 - on-going'
   }, {
      'degree': 'High School Diploma',
      'school': 'Gymnasium',
      'city': 'Gjilan',
      'timeline': '2013 - 2016'
   }
];

const activities = [
   {
      'name': 'Ministry of Data',
      'type': 'Hackathon',
      'role': 'Lead Software Developer',
      'organizer': 'GONG Croatia, TechSoup',
      'city': 'Zagreb, Croatia',
      'winner': true
   }, {
      'name': 'Nasa Space Apps 2017',
      'type': 'International Hackathon',
      'role': 'Project Manager/Lead Software Developer',
      'organizer': 'SpaceApps',
      'city': 'Pristina, Innovation Centre Kosovo',
      'winner': true
   }, {
      'name': 'Open Datathon',
      'type': 'Hackathon',
      'role': 'Software Developer',
      'organizer': 'Open Data Kosovo, ipkofoundation',
      'city': 'Pristina, Prishtina Hackerspace',
      'winner': true
   }, {
      'name': 'Making Sense',
      'type': 'Hackathon',
      'role': 'Software Developer',
      'organizer': 'Peer Educators Networks - PEN',
      'city': 'Pristina',
      'winner': false
   }
];

class Education extends Component {
   render() {
      return (
         <div className="main">
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Education</h3>
                  </div>
                  <div className="col-md-9">
                     {edu_data.map((data, index) => {
                        const {timeline, degree, school} = data;
                        return (
                           <div key={index} className="card-container edu">
                              <p className="company-name">{school}</p>
                              <p>{degree}</p>
                              <p>{timeline}</p>
                           </div>
                        )
                     })}
                  </div>
               </div><br/><br/>
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Activities & Achievements</h3>
                  </div>
                  <div className="col-md-9">
                     {activities.map((data, index) => {
                        const {
                           name,
                           type,
                           role,
                           organizer,
                           city,
                           winner
                        } = data;
                        return (
                           <div key={index} className="card-container edu">
                              <p className="company-name">{name}</p>
                              <p>{type}</p>
                              <p>{organizer}</p>
                              <p>{city}</p>
                              <p>{role}</p>
                              <p>{winner
                                    ? <h4>
                                          <span className="badge badge-warning win">Winner&nbsp;
                                             <i className="fa fa-trophy" aria-hidden="true"></i>
                                          </span>
                                       </h4>
                                    : ''}</p>
                           </div>
                        )
                     })}
                  </div>
               </div>
            </FadeIn>
         </div>
      );
   }
}

export default Education;



// WEBPACK FOOTER //
// ./src/components/Education.js